import { ChangeDetectionStrategy, Component, ElementRef, HostListener, effect, input, output, viewChild } from '@angular/core';

import { trapTabKey } from '../../utils/focus-trap.util';
import { ButtonComponent } from '../button/button.component';
import { ModalComponent } from '../modal/modal.component';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ModalComponent, ButtonComponent],
})
export class ConfirmDialogComponent {
  open = input.required<boolean>();
  title = input('');
  message = input('');
  confirmLabel = input('Confirmar');
  cancelLabel = input('Cancelar');
  variant = input<'default' | 'danger'>('default');
  submitting = input(false);

  confirmed = output<void>();
  cancelled = output<void>();

  private readonly cancelHost = viewChild<ElementRef<HTMLElement>>('cancelHost');
  private readonly dialogRoot = viewChild<ElementRef<HTMLElement>>('dialogRoot');
  private previousFocus: HTMLElement | null = null;

  private readonly manageFocus = effect(() => {
    if (this.open()) {
      this.previousFocus = document.activeElement as HTMLElement | null;
      setTimeout(() => this.cancelHost()?.nativeElement.querySelector('button')?.focus());
    } else {
      this.previousFocus?.focus();
      this.previousFocus = null;
    }
  });

  @HostListener('document:keydown.escape')
  protected onEscape(): void {
    if (this.open()) this.cancelled.emit();
  }

  @HostListener('document:keydown', ['$event'])
  protected onKeydown(event: KeyboardEvent): void {
    const root = this.dialogRoot()?.nativeElement;
    if (this.open() && root) trapTabKey(event, root);
  }
}
